import Route from 'route-parser';
import { goalUidSlugMap } from './constants';

const RouteIds = {
  GOAL_TYPE_NEW: 'GOAL_TYPE_NEW',
  GOAL_SUBSCRIBE_NEW: 'GOAL_SUBSCRIBE_NEW',
  PROFILE_ABOUT: 'PROFILE_ABOUT',
  PROFILE_FOLLOWS: 'PROFILE_FOLLOWS',
  PLUS_GOAL: 'PLUS_GOAL',
  PLUS_GOAL_SPECIAL_CLASS: 'PLUS_GOAL_SPECIAL_CLASS',
  PLUS_GOAL_TYPE: 'PLUS_GOAL_TYPE',
  PLUS_GOAL_TEST_TYPE: 'PLUS_GOAL_TEST_TYPE',
  PLUS_GOAL_TOPIC: 'PLUS_GOAL_TOPIC',
  PLUS_GOAL_TOPIC_TYPE: 'PLUS_GOAL_TOPIC_TYPE',
  PLUS_GOAL_RECOMMENDATION_COURSES: 'PLUS_GOAL_RECOMMENDATION_COURSES',
  FREE_GOAL_TOPIC: 'FREE_GOAL_TOPIC',
  FREE_GOAL_TOPIC_CONCEPT: 'FREE_GOAL_TOPIC_CONCEPT',
  COURSE: 'COURSE',
  GOAL_SUBSCRIBE: 'GOAL_SUBSCRIBE',
  GOAL_SLUG: 'GOAL_SLUG',
  CONTINUE_WATCHING: 'CONTINUE_WATCHING',
  MY_LISTS: 'MY_LISTS',
  PLUS_LESSON: 'PLUS_LESSON',
  MY_SCHEDULE: 'MY_SCHEDULE',
  USER: 'USER',
  QUIZ_RANK: 'QUIZ_RANK',
  MANAGE_UPDATES: 'MANAGE_UPDATES',
  PART_PAYMENTS: 'PART_PAYMENTS',
  EDUCATOR_LANDING: 'EDUCATOR_LANDING',
  MODERATOR_DASHBOARD: 'MODERATOR_DASHBOARD',
  EVENT_ASPIRE: 'EVENT_ASPIRE'
};

const routesList = [
  {
    id: RouteIds.GOAL_TYPE_NEW,
    oldRoute: new Route('/goal/:goalSlug/:goalUID/:type'),
    newRoute: null,
    newRouteHref: null
  },
  {
    id: RouteIds.GOAL_SUBSCRIBE_NEW,
    oldRoute: new Route('/goal/:goalSlug/:goalUID/subscribe'),
    newRoute: null,
    newRouteHref: null
  },
  {
    id: RouteIds.PROFILE_ABOUT,
    oldRoute: new Route('/:authorID/about'),
    newRoute: new Route('/:authorID'),
    newRouteHref: '/[authorID]'
  },
  {
    id: RouteIds.PREVIOUS_ENROLLED,
    oldRoute: new Route('/plus/plus-enrolled'),
    newRoute: new Route('/previous-enrolled-courses'),
    newRouteHref: '/previous-enrolled-courses'
  },
  {
    id: RouteIds.PLUS_MAIN,
    oldRoute: new Route('/plus'),
    newRoute: new Route('/explore'),
    newRouteHref: '/explore'
  },
  {
    id: RouteIds.PROFILE_FOLLOWS,
    oldRoute: new Route('/:authorID/follows'),
    newRoute: new Route('/:authorID'),
    newRouteHref: '/[authorID]'
  },
  {
    id: RouteIds.PLUS_GOAL,
    oldRoute: new Route('/plus/goal/:goalUID'),
    newRoute: new Route('/goal/:goalSlug/:goalUID'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]'
  },
  {
    id: RouteIds.PLUS_GOAL_SPECIAL_CLASS,
    oldRoute: new Route('/plus/goal/:goalUID/special_class'),
    newRoute: new Route('/goal/:goalSlug/:goalUID/classes'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]/classes'
  },
  {
    id: RouteIds.PLUS_GOAL_TYPE,
    oldRoute: new Route('/plus/goal/:goalUID/:type'),
    newRoute: new Route('/goal/:goalSlug/:goalUID/:type'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]/[type]'
  },
  {
    id: RouteIds.PLUS_GOAL_TEST_TYPE,
    oldRoute: new Route('/plus/goal/:goalUID/test_series/:type'),
    newRoute: new Route('/goal/:goalSlug/:goalUID/test_series'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]/[type]'
  },
  {
    id: RouteIds.PLUS_GOAL_TOPIC,
    oldRoute: new Route('/plus/goal/:goalUID/topic/:topicUid'),
    newRoute: new Route('/goal/:goalSlug/:goalUID/topic/:topicUid'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]/topic/[topicUid]'
  },
  {
    id: RouteIds.PLUS_GOAL_TOPIC_TYPE,
    oldRoute: new Route('/plus/goal/:goalUID/topic/:topicUid/:type'),
    newRoute: new Route('/goal/:goalSlug/:goalUID/topic/:topicUid/courses'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]/topic/[topicUid]/courses'
  },
  {
    id: RouteIds.PLUS_GOAL_RECOMMENDATION_COURSES,
    oldRoute: new Route('/plus/goal/:goalUID/recommendation/courses'),
    newRoute: new Route('/goal/:goalSlug/:goalUID/onboarding'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]/onboarding'
  },
  // {
  //   id: RouteIds.FREE_GOAL_TOPIC,
  //   oldRoute: new Route('/goal/:goalSlug/:topicSlugType/:topicSlugUID'),
  //   newRoute: new Route(
  //     '/goal/:goalSlug/:goalUID/free-platform/:topicSlugType/:topicSlugUID'
  //   ),
  //   newRouteHref:
  //     '/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]'
  // },
  // {
  //   id: RouteIds.FREE_GOAL_TOPIC_CONCEPT,
  //   oldRoute: new Route(
  //     '/goal/:goalSlug/:topicSlugType/:conceptSlug/:conceptUID'
  //   ),
  //   newRoute: new Route(
  //     '/goal/:goalSlug/:goalUID/free-platform/:topicSlugType/:topicSlugUID/:conceptUID'
  //   ),
  //   newRouteHref:
  //     '/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]/[conceptUID]'
  // },
  {
    id: RouteIds.PLUS_TEST_SERIES,
    oldRoute: new Route('/plus/course/:courseSlug/:courseUID'),
    newRoute: new Route('/course/:courseSlug/:courseUID'),
    newRouteHref: '/course/[courseSlug]/[courseUID]'
  },
  {
    id: RouteIds.COURSE,
    oldRoute: new Route('/plus/test-series/:slug/:courseUID'),
    newRoute: new Route('/test-series/:slug/:courseUID'),
    newRouteHref: '/test-series/[slug]/[courseUID]'
  },
  {
    id: RouteIds.GOAL_SUBSCRIBE,
    oldRoute: new Route('/subscribe/:goalUID'),
    newRoute: new Route('/goal/:goalSlug/:goalUID/subscribe'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]/subscribe'
  },
  {
    id: RouteIds.PART_PAYMENTS,
    oldRoute: new Route('/goal/:goalSlug/:goalUID/subscribe/part-payment'),
    newRoute: new Route('/goal/:goalSlug/:goalUID/subscribe'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]/subscribe'
  },
  {
    id: RouteIds.GOAL_SLUG,
    oldRoute: new Route('/goal/:goalSlug/:goalUID'),
    newRoute: new Route('/goal/:goalSlug/:goalUID'),
    newRouteHref: '/goal/[goalSlug]/[goalUID]'
  },
  {
    id: RouteIds.MODERATOR_DASHBOARD,
    oldRoute: new Route('/dashboard/:type'),
    newRoute: new Route('/moderator/dashboard/:type'),
    newRouteHref: '/moderator/dashboard/[type]'
  },
  {
    id: RouteIds.EDUCATOR_LANDING,
    oldRoute: new Route('/educator/plus'),
    newRoute: new Route('/educator'),
    newRouteHref: '/educator'
  },
  {
    id: RouteIds.CONTINUE_WATCHING,
    oldRoute: new Route('/continue-watching'),
    newRoute: new Route('/library'),
    newRouteHref: '/library'
  },
  {
    id: RouteIds.MY_LISTS,
    oldRoute: new Route('/my-lists'),
    newRoute: new Route('/library'),
    newRouteHref: '/library'
  },
  {
    id: RouteIds.PLUS_LESSON,
    oldRoute: new Route('/plus/lesson/:slug/:uid'),
    newRoute: new Route('/class/:slug/:uid'),
    newRouteHref: '/class/[slug]/[uid]'
  },
  {
    id: RouteIds.EVENT_ASPIRE,
    oldRoute: new Route('/event/testseries/ASPIRE'),
    newRoute: new Route('/event/testseries/aspire'),
    newRouteHref: '/event/testseries/aspire'
  },
  {
    id: RouteIds.MY_SCHEDULE,
    oldRoute: new Route('/myschedule'),
    newRoute: new Route('/'),
    newRouteHref: '/index'
  },
  {
    id: RouteIds.USER,
    oldRoute: new Route('/user/:userName'),
    newRoute: new Route('/@:userName'),
    newRouteHref: '/[authorID]'
  },
  {
    id: RouteIds.QUIZ_RANK,
    oldRoute: new Route('/quiz/:quizSlug/:quizUID/:rank'),
    newRoute: new Route('/quiz/:quizSlug/:quizUID'),
    newRouteHref: '/quiz/[quizSlug]/[quizUID]'
  },
  {
    id: RouteIds.MANAGE_UPDATES,
    oldRoute: new Route('/updates/manage'),
    newRoute: new Route('/settings'),
    newRouteHref: '/settings'
  }
];

const getNewUrl = (rawOldUrl) => {
  let oldUrl = rawOldUrl;
  if (rawOldUrl && rawOldUrl.endsWith('/')) {
    oldUrl = rawOldUrl
      .split('')
      .splice(0, rawOldUrl.length - 1)
      .join('');
  }

  for (let i = 0; i < routesList.length; i += 1) {
    const route = routesList[i];
    const { id, oldRoute, newRoute, newRouteHref } = route;
    const params = oldRoute.match(oldUrl);
    let query = oldUrl.includes('?') ? oldUrl.split('?')[1] : '';
    query = query ? `?${query}` : '';

    if (id === RouteIds.MANAGE_UPDATES) {
      query = query === '' ? '?updates=true' : `${query}&updates=true`;
    }

    if (params) {
      switch (id) {
        case RouteIds.GOAL_TYPE_NEW:
        case RouteIds.GOAL_SUBSCRIBE_NEW:
          return null;

        case RouteIds.GOAL_SLUG:
          if (
            goalUidSlugMap[params.goalUID] &&
            params.goalSlug !== goalUidSlugMap[params.goalUID]
          ) {
            params.goalSlug = goalUidSlugMap[params.goalUID] || '-';
            return {
              href: newRouteHref,
              as: `${newRoute.reverse({ ...params })}${query}`
            };
          }
          return null;
        case RouteIds.PLUS_GOAL:
        case RouteIds.PLUS_GOAL_SPECIAL_CLASS:
        case RouteIds.PLUS_GOAL_TYPE:
        case RouteIds.GOAL_SUBSCRIBE:
        case RouteIds.PART_PAYMENTS:
        case RouteIds.EVENT_ASPIRE:
        case RouteIds.EDUCATOR_LANDING:
        case RouteIds.MODERATOR_DASHBOARD:
        case RouteIds.PLUS_GOAL_TEST_TYPE:
        case RouteIds.PLUS_GOAL_TOPIC:
        case RouteIds.PLUS_GOAL_TOPIC_TYPE:
        case RouteIds.PLUS_GOAL_RECOMMENDATION_COURSES:
          params.goalSlug = goalUidSlugMap[params.goalUID] || '-';
          return {
            href: newRouteHref,
            as: `${newRoute.reverse({ ...params })}${query}`
          };

        case RouteIds.PREVIOUS_ENROLLED:
        case RouteIds.PLUS_MAIN:
        case RouteIds.PROFILE_ABOUT:
        case RouteIds.PROFILE_FOLLOWS:
        case RouteIds.PLUS_TEST_SERIES:
        case RouteIds.COURSE:
        case RouteIds.CONTINUE_WATCHING:
        case RouteIds.MY_LISTS:
        case RouteIds.PLUS_LESSON:
        case RouteIds.MY_SCHEDULE:
        case RouteIds.QUIZ_RANK:
        case RouteIds.MANAGE_UPDATES:
        case RouteIds.USER:
          return {
            href: newRouteHref,
            as: `${newRoute.reverse({ ...params })}${query}`
          };

        // case RouteIds.FREE_GOAL_TOPIC:
        //   params.goalUID = goalSlugUidMap[params.goalSlug] || '-';
        //   return {
        //     href: newRouteHref,
        //     as: `${newRoute.reverse({ ...params })}${query}`
        //   };

        // case RouteIds.FREE_GOAL_TOPIC_CONCEPT:
        //   params.topicSlugUID = '-';
        //   params.goalUID = goalSlugUidMap[params.goalSlug] || '-';
        //   return {
        //     href: newRouteHref,
        //     as: `${newRoute.reverse({ ...params })}${query}`
        //   };

        default: {
          return null;
        }
      }
    }
  }
};

export default { getNewUrl, goalUidSlugMap };
